import {TableButtonOptions} from "../../../Modules/ListPage/Components/Table/Buttons/TableButtonGroup";
import {ProfileButton} from "../../../Modules/ListPage/Components/Table/Buttons/ProfileButton";
import React from "react";


const USER_SCHEMA_NAME = 'auth_users';

export const UserCustomListSchema = (name, schema) => {

    const endpoint = `${process.env.REACT_APP_NODE_SERVICE}/auth/users/`;
    console.log('Customizando user list schema', name, schema)
    if (!(name === USER_SCHEMA_NAME)) {
        return;
    }

    schema.getEndpoint = () => {
        return endpoint;
    }

    schema.getColumns = () => {


        return [
            TableButtonOptions({
                deleteEndpoint: endpoint,
                width: 250,
                children: ({row}) => {
                    return [
                        <ProfileButton key={"edit_" + row.id} row={row}/>,
                    ]
                }
            }),
            {
                header: 'Nome',
                accessorKey: 'name',
                /*enableSorting: false,
                export: false,
                collapse: true,
                enableColumnFilter: true,*/
            },
            {
                header: 'E-mail',
                accessorKey: 'email',
            },
            {
                header: 'Ativo',
                accessorKey: 'activated',
                type: 'boolean',
                cell: ({row}) => {
                    return row.original.tenantAccess[0].activated ? 'Ativo' : 'Inátivo'
                }
                /*enableSorting: false,
                export: false,
                collapse: true,
                enableColumnFilter: true,*/
            }
        ]
    }
}


export const UserCustomFormSchema = (name, schema) => {
    if (!(name === USER_SCHEMA_NAME)) {
        return;
    }


    schema.formatObjectToGet = (data) => {
        console.log('data.tenantAccess', data);
        data.activated = data.tenantAccess[0].activated;
        return data;
    }

    schema.customValidate = (formData, errors) => {
        if (formData.password !== formData.newPasswordRepeat) {
            errors.password.addError("A senha não é igual!");
        }
        return errors;
    }

    schema.uiSchema = {}


    schema.getFormSchema = (name, params) => {
        const formSchema = {
            type: 'object',
            properties: {
                name: {
                    title: 'Nome',
                    type: "string",
                },
                activated: {
                    title: 'Ativo',
                    type: "boolean",
                    default: true,
                },
                email: {
                    title: 'E-mail',
                    type: "string",
                    format: "email"
                }
            },
            required: ['name', 'email'],

        };
        const {id} = params;

        if (id) {
            delete formSchema.properties.email
            formSchema.required = formSchema.required.filter(x => x !== 'email')
        } else {
            formSchema.properties.password = {
                type: "string",
                format: 'password',
                title: "Nova senha",
                "minLength": 6
            };
            formSchema.properties.newPasswordRepeat = {
                type: "string",
                format: 'password',
                title: "Repita a nova senha",
                "minLength": 6
            };
            formSchema.required.push('password');
            formSchema.required.push('newPasswordRepeat');
        }

        return formSchema;
    }


    schema.getSaveUrl = (id) => {
        return `${process.env.REACT_APP_NODE_SERVICE}auth/users/${id || ''}`;
    }

    schema.getByIdUrl = (id) => `${process.env.REACT_APP_NODE_SERVICE}auth/users/${id}`;

    schema.formatObjectToSave = (formData) => {
        return formData;
    };

}
